import type { SVGProps } from 'react';

export function InvoiceDocIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.667 1.667H5a1.667 1.667 0 0 0-1.667 1.666v13.334A1.667 1.667 0 0 0 5 18.333h10a1.667 1.667 0 0 0 1.667-1.666V6.667L11.667 1.667Z"
        stroke="currentColor"
        strokeWidth="1.667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.667 1.667v5h5"
        stroke="currentColor"
        strokeWidth="1.667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.667 7.5h1.666"
        stroke="currentColor"
        strokeWidth="1.667"
        strokeLinecap="round"
      />
      <path
        d="M6.667 10.833h6.666"
        stroke="currentColor"
        strokeWidth="1.667"
        strokeLinecap="round"
      />
      <path
        d="M6.667 14.167h6.666"
        stroke="currentColor"
        strokeWidth="1.667"
        strokeLinecap="round"
      />
    </svg>
  );
}
